/**
 * ── O CAPELO DA NEURA TUTORA ───────────────────────────────────────────────
 *
 * Ordem do dono, 01/10/2026: *«coloque uma label no agente de "Neura Tutora" com
 * um chapeuzinho de formando»*.
 *
 * Mora num ficheiro próprio porque **dois sítios o desenham**: a palavra da porta
 * flutuante, que entra sob o rato, e a barra do painel. Uma segunda cópia seria
 * duas verdades sobre a mesma marca — e é sempre a cópia que ninguém atualiza.
 *
 * Ele NÃO substitui a órbita. A órbita é a marca do agente, escolhida pelo dono
 * em 01/10 e medida nos dois temas; o capelo é o que acompanha o NOME. Um diz
 * «há alguém aqui», o outro diz quem.
 *
 * A prancha é um losango e não um retângulo em perspetiva: a 14 px a perspetiva
 * vira um borrão, e o losango lê-se como capelo em qualquer tamanho. A borla cai
 * à direita, que é o lado de onde a palavra cresce.
 */
export function Capelo({ tamanho = 14 }: { tamanho?: number }) {
  return (
    <svg
      aria-hidden
      viewBox="0 0 24 24"
      width={tamanho}
      height={tamanho}
      fill="none"
      className="vst-capelo"
    >
      {/* A prancha. */}
      <path
        d="M12 4 22 8.6 12 13.2 2 8.6 12 4Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinejoin="round"
      />
      {/* O corpo, por baixo dela. */}
      <path
        d="M6.6 10.7v3.9c0 1.4 2.4 2.4 5.4 2.4s5.4-1 5.4-2.4v-3.9"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* A borla. */}
      <path d="M20.4 9.4v4.3" stroke="currentColor" strokeWidth={1.3} strokeLinecap="round" />
      <circle cx="20.4" cy="15" r="1.3" fill="currentColor" />
    </svg>
  );
}
